import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const SettlementDetailsView = () => {
  const { ReleaseId } = useParams();
  const [blockDetails, setBlockDetails] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettlementData = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel-blocking/view-settlement_details/${ReleaseId}`
        );
        console.log("response.data.blockDetails", response.data.blockDetails);
        setBlockDetails(response.data.blockDetails);
        setPayments(response.data.payments);
      } catch (err) {
        console.error("Error fetching settlement data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettlementData();
  }, [ReleaseId]);

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  if (!blockDetails)
    return <div className="alert alert-danger mt-4">No block data found.</div>;

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Block Settlement Details</h4>

      <div className="card mb-4">
        <div className="card-body">
          <p>
            <strong>Customer Name:</strong> {blockDetails.customer_name}
          </p>
          <p>
            <strong>Hotel:</strong> {blockDetails.hotel_name}
          </p>
          <p>
            <strong>Block From:</strong>{" "}
            {blockDetails?.dtmBlockFromDate
              ? blockDetails.dtmBlockFromDate.split("T")[0]
              : ""}
          </p>

          <p>
            <strong>Block To:</strong>{" "}
            {blockDetails?.dtmBlockToDate
              ? blockDetails.dtmBlockToDate.split("T")[0]
              : ""}
          </p>

          <p>
            <strong>Blocked On:</strong>
            {blockDetails?.dtmCreated
              ? blockDetails.dtmCreated.split("T")[0]
              : ""}
          </p>

          <p>
            <strong>Remarks:</strong> <span>{blockDetails.vchRemarks}</span>
          </p>
        </div>
      </div>

      <h5>Payment History</h5>
      {payments.length === 0 ? (
        <div className="alert alert-warning">No payments found.</div>
      ) : (
        <table className="table table-bordered table-striped">
          <thead className="table-light">
            <tr>
              <th>Amount Paid</th>
              <th>Payment Date</th>
              <th>Serial Number</th>
              <th>Attachment</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((pmt) => (
              <tr key={pmt.intPaymentID}>
                <td>₹{pmt.amount_paid}</td>
                <td>{new Date(pmt.payment_date).toLocaleDateString()}</td>
                <td>{pmt.serial_number}</td>
                {pmt.attachment_name ? (
                  <a
                    href={`${REACT_APP_API_URL}uploads/${pmt.attachment_name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {pmt.attachment_name}
                  </a>
                ) : (
                  "N/A"
                )}
                <td>{pmt.remarks || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SettlementDetailsView;
